<script setup lang="ts">
import { useRouter } from "vue-router";
import { Product } from "~/utils/Product";
import {useUserDataStorage} from "~/store/userdata";
import {useModyApi} from "~/middelware/ModyApi";
import {useToast} from "primevue/usetoast";
import { addToCart } from "~/utils/Cart";

const amount = ref(1)
const props = defineProps<{ product: Product, skeleton?:Boolean}>();
const router = useRouter();
const userStore = useUserDataStorage()
const imgLoaded = ref(false)
const api = useModyApi()
const toast = useToast()

</script>

<template>
  <Toast>
    <template #message="slotProps">
      <div style="width:100%">
        {{slotProps.message.detail}}
        <div @click.stop="router.push('/shop/request')" style="text-decoration: underline;cursor:pointer">
          zur Anfrage
        </div>
      </div>
    </template>
  </Toast>
  <div class="productItem" @click="router.push('/shop/product/' + product.id)" v-if="skeleton==true">
    <Skeleton height="10rem" style="margin-bottom:30px"></Skeleton>
    <Skeleton height="3rem"></Skeleton>
  </div>
  <div class="productItem" @click="router.push('/shop/product/' + product.id)" v-else>
    <div class="img-container">
      <img :hidden="!imgLoaded" :src="product.Images[0]" :alt="product.Name" @load="imgLoaded=true"/>
      <Skeleton v-if="!imgLoaded" height="10rem"></Skeleton>
    </div>
    <div class="title">{{ product.Name }}</div>
    <div class="price">
      <template v-if="product.Price != 0">{{ product.Price.toLocaleString("de-AT", {style: "currency", currency: "EUR"}) }}</template>
      <template v-else>Preis auf Anfrage</template>
    </div>
    <div class="price-and-button">
      <InputNumber @click.stop v-model="amount" inputId="integeronly" showButtons buttonLayout="horizontal" :min="0"/>
      <Button class="button pi pi-cart-plus" @click.stop="addToCart(amount,product,toast)" outlined></Button>
    </div>
  </div>
</template>
<style scoped lang="scss">


.productItem {
  border: 1px none rgba(255, 255, 255, 0.35);
  border-radius:0;
  color: rgb(97, 97, 97);
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  margin:20px;
  padding:20px;
}

.img-container{
  height: 200px;
  display: block;
  img {
    background:$imgBackground;
    border-radius: 20px;
    width:100%;
    height:100%;
    object-fit: contain;
  }
}
.title{
  margin-top:10px;
  color:white;
  font-weight:bold;
  font-size:14px;
  word-break:break-word;
  @include desktop(){
    margin-top:17px;
  }
}
.price {
  text-align: left;
  width: 100%;
  font-weight: 100;
  font-size: 20px;
  color: white;
}
.price-and-button{
  margin-top: 10px;
  width: 100%;
  .p-inputnumber{
    max-width:100%;
    overflow:hidden;
    :deep(.p-inputtext){
      width:100%;
    }
  }
  .button {
    margin-top:10px;
    font-size: 15px;
    padding:10px;
    width:100%;
  }
}
</style>
